import React, { createContext, MutableRefObject, useContext, useRef, useState } from 'react';

interface DomContextType {
  headerCartIconRef: MutableRefObject<any>;
  headerAccountIconRef: MutableRefObject<HTMLAnchorElement | null>;
  modalWindowMountPointRef: MutableRefObject<any>;
  headerNavigationRef: MutableRefObject<HTMLDivElement | null>;
  disableScrollHide: boolean;
  setDisableScrollHide: (disableScrollHide: boolean) => void;
}

const DomContext = createContext<DomContextType>({} as any);

export const DomContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const headerCartIconRef = useRef();
  const headerAccountIconRef = useRef(null);
  const modalWindowMountPointRef = useRef<any>();
  const headerNavigationRef = useRef<HTMLDivElement | null>(null);
  const [disableScrollHide, setDisableScrollHide] = useState(false);

  const value = {
    headerCartIconRef,
    modalWindowMountPointRef,
    headerNavigationRef,
    headerAccountIconRef,
    disableScrollHide,
    setDisableScrollHide,
  };

  return (
    <DomContext.Provider value={value}>
      <div ref={modalWindowMountPointRef} />
      {children}
    </DomContext.Provider>
  );
};

export const useDom = () => useContext(DomContext);
